module.exports = __webpack_public_path__ + "img/trans-posted.53dcae50.svg";